import { Subscription } from 'rxjs';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { TabComponent, TabModule } from '@syncfusion/ej2-angular-navigations';
import { ExportInterfaceConfigurationFileProcessType, ExportInterfaceConfigurationMode, ExportInterfaceConfigurationTransferType, ExportInterfaceConfigurationType } from 'src/app/base/models/models.swagger.generated';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationFormFileComponent } from '../configuration-form-file/configuration-form-file.component';
import { ConfigurationFormRestComponent } from '../configuration-form-rest/configuration-form-rest.component';
import { ConfigurationFormFtpComponent } from '../configuration-form-ftp/configuration-form-ftp.component';
import { ConfigurationFormLbsftpComponent } from '../configuration-form-lbsftp/configuration-form-lbsftp.component';
import { ConfigurationFormEmailComponent } from '../configuration-form-email/configuration-form-email.component';
import { ConfigurationFormTimeplanComponent } from '../configuration-form-timeplan/configuration-form-timeplan.component';
import { ConfigurationFormFinanceComponent } from '../configuration-form-finance/configuration-form-finance.component';
import { ConfigurationFormBacklogComponent } from '../configuration-form-backlog/configuration-form-backlog.component';
import { ConfigurationFormGeneralComponent } from '../configuration-form-general/configuration-form-general.component';
import { Location } from '@angular/common';
import * as pages from '../../../../../core/routing/page-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import { Router } from '@angular/router';

@Component({
    selector: 'app-configuration-forms-overview',
    templateUrl: './configuration-forms-overview.component.html',
    styleUrls: ['./configuration-forms-overview.component.scss'],
    imports: [TabModule, ConfigurationFormGeneralComponent, ConfigurationFormBacklogComponent, ConfigurationFormFinanceComponent, ConfigurationFormTimeplanComponent, ConfigurationFormEmailComponent, ConfigurationFormLbsftpComponent, ConfigurationFormFtpComponent, ConfigurationFormRestComponent, ConfigurationFormFileComponent, TranslateModule]
})

export class ConfigurationFormsOverviewComponent implements OnInit, OnDestroy {
  @ViewChild(TabComponent) public tab: TabComponent;

  @ViewChild(ConfigurationFormFileComponent)
  public configurationFormFileComponent: ConfigurationFormFileComponent;

  public FileProcessType = ExportInterfaceConfigurationFileProcessType;

  private transferTypeChangedSubscription: Subscription;
  private modeChangedSubscription: Subscription;
  private isGetUrl = false;

  private TAB_GENERAL = 0;
  private TAB_BACKLOG = 1;
  private TAB_FINANCE = 2;
  private TAB_TIMEPLAN = 3;
  private TAB_EMAIL = 4;
  private TAB_LBSFTP = 5;
  private TAB_FTPCLIENT = 6;
  private TAB_REST = 7;
  private TAB_FILE = 8;
  constructor(
    public configurationFormService: ConfigurationFormCoordinatorService,
    private configurationFormCoordinatorService: ConfigurationFormCoordinatorService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit() {
    this.transferTypeChangedSubscription = this.configurationFormService.transferTypeChanged.subscribe((transferType) => {
      this.updateTabs(transferType);
    });
    this.modeChangedSubscription = this.configurationFormCoordinatorService.configurationFormGeneral.controls.mode.valueChanges.subscribe((mode) => {
      this.updateTabs(this.configurationFormService.transferType);
    });
    this.transferTypeChangedSubscription.add(this.configurationFormService.typeChanged.subscribe((type) => {
      this.tab?.hideTab(this.TAB_BACKLOG, type !== ExportInterfaceConfigurationType.CustomerBacklog);
      this.tab?.hideTab(this.TAB_FINANCE, type !== ExportInterfaceConfigurationType.Finance);
      if(type === ExportInterfaceConfigurationType.XMLOrder
        || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder
        || this.configurationFormService.transferType === ExportInterfaceConfigurationTransferType.AS2
        || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection)
      {
        this.tab?.hideTab(this.TAB_TIMEPLAN, true);
        this.tab?.hideTab(this.TAB_EMAIL, true);
        this.tab?.hideTab(this.TAB_LBSFTP, true);
        this.tab?.hideTab(this.TAB_FTPCLIENT, true);
        this.tab?.hideTab(this.TAB_REST, true);
        this.tab?.hideTab(this.TAB_FILE, true);
      }
      else{
        this.updateTabs(this.configurationFormService.transferType);
      }

    }));
  }

  ngOnDestroy(): void {
    this.transferTypeChangedSubscription?.unsubscribe();
    this.modeChangedSubscription?.unsubscribe();
  }

  public animation: object = {
    previous: { effect: "", duration: 0, easing: "" },
    next: { effect: "", duration: 0, easing: "" }
  };

  public get id(): number {
    return this.configurationFormService.configurationDetailsDTO?.id;
  }

  public select(event): void {
    if (event.isSwiped) {
      event.cancel = true;
    }
    this.setUrlRoute(event.selectingIndex);
  }

  public onTabsCreated(event: any) {
    this.updateTabs(this.configurationFormService.transferType);
    this.getUrlRoute();
  }

  private updateTabs(transferType) {
    if (transferType === null || transferType === undefined) {
      return;
    }
    this.tab?.hideTab(this.TAB_BACKLOG, this.configurationFormService.configurationType !== ExportInterfaceConfigurationType.CustomerBacklog);
    this.tab?.hideTab(this.TAB_FINANCE, this.configurationFormService.configurationType !== ExportInterfaceConfigurationType.Finance);
    this.tab?.hideTab(this.TAB_TIMEPLAN, transferType === ExportInterfaceConfigurationTransferType.REST
      || transferType === ExportInterfaceConfigurationTransferType.SFTPServerOnly
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder
      || this.configurationFormService.configurationFormGeneral.controls.mode.value === ExportInterfaceConfigurationMode.Response);
    this.tab?.hideTab(this.TAB_EMAIL, transferType !== ExportInterfaceConfigurationTransferType.Email
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder);
    this.tab?.hideTab(this.TAB_LBSFTP, (transferType !== ExportInterfaceConfigurationTransferType.SFTPServer
      && transferType !== ExportInterfaceConfigurationTransferType.SFTPServerOnly)
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder);
    this.tab?.hideTab(this.TAB_FTPCLIENT, transferType !== ExportInterfaceConfigurationTransferType.FTPClient
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder);
    this.tab?.hideTab(this.TAB_REST, transferType !== ExportInterfaceConfigurationTransferType.REST
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder);
    this.tab?.hideTab(this.TAB_FILE, transferType === ExportInterfaceConfigurationTransferType.SFTPServerOnly
      || transferType === ExportInterfaceConfigurationTransferType.AS2
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.XMLOrder
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.CustomerConnection
      || this.configurationFormService.configurationType === ExportInterfaceConfigurationType.EDIOrder);
  }

  public getUrlRoute() {
    var pageRoute = UrlHelper.getTabSegmentForConfigurations(this.router, pages.configurationsPageName);
    if (pageRoute === pages.importConfigurationsResponsePageName){
      pageRoute = UrlHelper.getTabSegmentForResponseExportConfiguration(this.router);
    }

    if (pageRoute == null || pageRoute == undefined){
      return;
    }

    this.isGetUrl = true;

    switch (pageRoute) {
      case pages.configurationGeneralPageName:
        this.tab?.select(this.TAB_GENERAL);
        break;
      case pages.configurationBacklogPageName:
        this.tab?.select(this.TAB_BACKLOG);
        break;
      case pages.configurationFinancePageName:
        this.tab?.select(this.TAB_FINANCE);
        break;
      case pages.configurationTimeSchedulePageName:
        this.tab?.select(this.TAB_TIMEPLAN);
        break;
      case pages.configurationEmailPageName:
        this.tab?.select(this.TAB_EMAIL);
        break;
      case pages.configurationSftpPageName:
        this.tab?.select(this.TAB_LBSFTP);
        break;
      case pages.configurationFtpPageName:
        this.tab?.select(this.TAB_FTPCLIENT);
        break;
      case pages.configurationRestPageName:
        this.tab?.select(this.TAB_REST);
        break;
      case pages.configurationFilePageName:
        this.tab?.select(this.TAB_FILE);
        break;
      default:
        this.tab?.select(this.TAB_GENERAL);
        break;
    }
  }

  private setUrlRoute(index: number) {
    //Catch the call of the function when comming over url
    if (this.isGetUrl) {
      this.isGetUrl = false;
      return;
    }

    var base = this.location.path() + '/../';
    if (base.includes(pages.configurationFileGeneralPageName) ||
    base.includes(pages.configurationFileColumnBasedPageName) ||
    base.includes(pages.configurationFileEdifactPageName) ||
    base.includes(pages.configurationFileAcodisPageName)){
      base += '../';
    }
    switch (index) {
      case this.TAB_GENERAL:
        this.location.replaceState(base + pages.configurationGeneralPageName);
        break;
      case this.TAB_BACKLOG:
        this.location.replaceState(base + pages.configurationBacklogPageName);
        break;
      case this.TAB_FINANCE:
        this.location.replaceState(base + pages.configurationFinancePageName);
        break;
      case this.TAB_TIMEPLAN:
        this.location.replaceState(base + pages.configurationTimeSchedulePageName);
        break;
      case this.TAB_EMAIL:
        this.location.replaceState(base + pages.configurationEmailPageName);
        break;
      case this.TAB_LBSFTP:
        this.location.replaceState(base + pages.configurationSftpPageName);
        break;
      case this.TAB_FTPCLIENT:
        this.location.replaceState(base + pages.configurationFtpPageName);
        break;
      case this.TAB_REST:
        this.location.replaceState(base + pages.configurationRestPageName);
        break;
      case this.TAB_FILE:
        this.location.replaceState(base + pages.configurationFilePageName);
        this.configurationFormFileComponent?.getUrlRoute();
        break;
    }
  }
}
